// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { createTheme } from '@mui/material';
import digitalAssetLogo from '../assets/digitalAssetLogo.png';
import digitalAssetLogoBlack from '../assets/digitalAssetLogoBlack.png';
import digitalAssetLogoWhite from '../assets/digitalAssetLogoWhite.png';
import { Branding } from '../utils/branding';
import baseline from './baseline';

const utilies: Branding = {
  loginLogo: <img alt="" src={digitalAssetLogoBlack} height="64" />,
  loginLogoDark: <img alt="" src={digitalAssetLogoWhite} height="64" />,
  headerLogo: <img alt="" src={digitalAssetLogoBlack} height="32px" />,
  headerLogoDark: <img alt="" src={digitalAssetLogoWhite} height="32px" />,
  companyLogo: (
    <img alt="" src={digitalAssetLogo} height="18px" style={{ display: 'inline-block' }} />
  ),
};

export default { branding: utilies, theme: createTheme(baseline) };
